export class ModuleDataHandler {
  moduleData: any;

  constructor(moduleData: any) {
    this.moduleData = moduleData;
  }

  calculateSalePlanAmount(rowIdx: number) {
    const saleRate = this.moduleData[rowIdx].sale_rate;
    const salePlan = this.moduleData[rowIdx].sale_plan;

    this.moduleData[rowIdx].sale_plan_amount =
      saleRate && salePlan && Number(saleRate * salePlan).toFixed(2);
  }

  //   total dispatch and sale amount are corelated
  calculateTotalDispatch(rowIdx: number) {
    const totalDispatch = this.moduleData[rowIdx].qty_days_arr.reduce(
      (accumulator: any, currentValue: any) => {
        if (currentValue) {
          return +accumulator + +currentValue;
        }
        return accumulator;
      },
      0
    );

    this.moduleData[rowIdx].total_dispatch = Number(totalDispatch);
  }
  // ⬆️⬇️
  calculateSaleAmount(rowIdx: number) {
    const totalDispatch = this.moduleData[rowIdx].total_dispatch;
    const saleRate = this.moduleData[rowIdx].sale_rate;

    if (saleRate && totalDispatch >= 0) {
      const saleAmount = (Number(saleRate) * totalDispatch).toFixed(2);
      this.moduleData[rowIdx].sale_amount = +saleAmount;
    }
  }

  //
  calculateBalance(rowIdx: number) {
    const totalDispatch = this.moduleData[rowIdx].total_dispatch;
    const salePlan = this.moduleData[rowIdx].sale_plan;

    this.moduleData[rowIdx].balance =
      salePlan && totalDispatch && +salePlan - +totalDispatch;
  }

  // calcuate RM Input (Kg)
  calculateTotalRmInput(rowIdx: number) {
    const rm_input_wg_total = this.moduleData?.[rowIdx].rm_days_arr.reduce(
      (accumulator: any, currentValue: any) => {
        if (currentValue) {
          return +accumulator + +currentValue;
        }
        return accumulator;
      },
      0
    );

    this.moduleData[rowIdx].rm_input_weight = rm_input_wg_total;
  }

  calculateRmInputQty(rowIdx: number) {
    const rm_input_wg_total = this.moduleData[rowIdx].rm_input_weight;
    const gross_wt = this.moduleData[rowIdx].rm_gross_wt;

    this.moduleData[rowIdx].rm_input_qty =
      rm_input_wg_total &&
      gross_wt &&
      Number(rm_input_wg_total / gross_wt).toFixed(3);
  }

  // Total Inventory (Qty)
  calculateRmTotalInventryQty(rowIdx: number) {
    const inventry_kg = this.moduleData[rowIdx].inventry_wgt_rm;
    const inventry_qty = this.moduleData[rowIdx].inventry_qty_rm;
    const gross_wt = this.moduleData[rowIdx].rm_gross_wt;

    // Total Inventory (Qty)
    this.moduleData[rowIdx].total_inventry_qty =
      inventry_kg &&
      inventry_qty &&
      gross_wt &&
      Math.round(inventry_kg / gross_wt + inventry_qty);
  }

  // RM required (Qty)
  calculateRmRequiredQty(rowIdx: number) {
    const total_inventry_qty = this.moduleData[rowIdx].total_inventry_qty;
    const sale_plan = this.moduleData[rowIdx].sale_plan;

    this.moduleData[rowIdx].rm_required_qty =
      sale_plan && Math.round(sale_plan - (total_inventry_qty || 0));
  }

  //RM required (Kg)
  calculateRmRequiredWeight(rowIdx: number) {
    const rm_required_qty = this.moduleData[rowIdx].rm_required_qty;
    const gross_wt = this.moduleData[rowIdx].rm_gross_wt;

    this.moduleData[rowIdx].rm_required_weight =
      rm_required_qty && gross_wt && Math.round(rm_required_qty * gross_wt);
  }

  //Balance RM Req (Kg)
  calculateRmBalance(rowIdx: number) {
    const rm_required_kg = this.moduleData[rowIdx].rm_required_weight;
    const rm_input = this.moduleData[rowIdx].rm_input_weight;

    this.moduleData[rowIdx].balance_rm =
      rm_required_kg && rm_required_kg - (rm_input || 0);
  }

  //   Closing Inventory (Qty)
  calculateRmClosingInventory(rowIdx: number) {
    const total_dispatch = this.moduleData[rowIdx].total_dispatch;
    const rm_input = this.moduleData[rowIdx].rm_input_weight;
    const gross_wt = this.moduleData[rowIdx].rm_gross_wt;

    const total_inventry_qty = this.moduleData[rowIdx].total_inventry_qty;

    this.moduleData[rowIdx].closing_inventry_qty =
      total_inventry_qty &&
      rm_input &&
      gross_wt &&
      total_dispatch &&
      Math.round(total_inventry_qty + rm_input / gross_wt - total_dispatch);
  }

  //
  syncSaleRate(rowIdx: number) {
    this.calculateSaleAmount(rowIdx);
    this.handelSaleplanamountAndBalance(rowIdx);

    // this for RM PLANNING Update 🛑
    this.calculateRmClosingInventory(rowIdx);
  }

  //handle total dispatch and sale amount use in MONTHLY SALES REPORT
  handleTotalDispatchAndSaleAmount(rowIdx: number) {
    this.calculateTotalDispatch(rowIdx);
    this.calculateSaleAmount(rowIdx);

    // for update MONTHLY SALES PLAN
    this.calculateBalance(rowIdx);

    // this for RM PLANNING Update 🛑
    this.calculateRmClosingInventory(rowIdx);
  }

  // handle Sale Plan Amount and Balance in MONTHLY SALES PLAN
  handelSaleplanamountAndBalance(rowIdx: number) {
    this.calculateSalePlanAmount(rowIdx);
    this.calculateBalance(rowIdx);

    // this for RM PLANNING Update .🛑
    this.calculateRmRequiredQty(rowIdx);
    this.calculateRmRequiredWeight(rowIdx);
    this.calculateRmBalance(rowIdx);
  }

  // handle rm input days accumulation in RM INPUT REPORT
  handelRmInputWeightAndQty(rowIdx: number) {
    this.calculateTotalRmInput(rowIdx);
    this.calculateRmInputQty(rowIdx);

    // this for RM PLANNING Update 🛑
    this.calculateRmBalance(rowIdx);
    this.calculateRmClosingInventory(rowIdx);
  }

  //handle all calculation of RM PLANNING
  handelRmPlanningCalc(rowIdx: number) {
    this.calculateRmTotalInventryQty(rowIdx);
    this.calculateRmRequiredQty(rowIdx);
    this.calculateRmRequiredWeight(rowIdx);
    this.calculateRmBalance(rowIdx);
    this.calculateRmClosingInventory(rowIdx);
  }

  private getPart(rowIdx: number) {
    return this.moduleData[rowIdx];
  }

  private updatePartProperty(rowIdx: number, property: string, value: any) {
    this.moduleData[rowIdx][property] = value;
  }
}
